import { Dialog } from "@mui/material";
import React from "react";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import CustomImageSlider from "../../../CheckOut/components/OrderTableDialog/CustomImageSlider";
import "./RestaurantPostModal.css";
import Swal from "sweetalert2";
import axios, { Axios } from "axios";
import EditShareYourThoughtsModal from "../../../../components/EditShareYourThoughtsComponents/Components/EditShareYourThoughtsModal";

export default function RestaurantPostModal({
  show,
  onHide,
  postInfo,
  restaurantLogo,
  restaurantName,
  postData,
}) {
  const apiAddress = process.env.REACT_APP_SECRET;
  const [editPostData, setEditPostData] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);

  const removePost = async (id, postInfoId) => {
    const result = await Swal.fire({
      title: "Do you want to delete this post?",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      zIndex: "5000",
    });

    if (result.isConfirmed) {
      try {
        // setLoading(true);
        await axios.delete(
          `${apiAddress}/api/Post/DeletePostByPostId?postId=${id}&postInfoId=${postInfoId}`
        );
        // isDeleted();
        // setLoading(false);
      } catch (error) {
        // setLoading(false);
        Swal.fire("Error!", "There was a problem deleting your post.", "error");
      }
    }
  };

  const showEditShareModalInfo = (postData) => {
    setEditPostData(postData);
    setShowEditModal(true);
    console.log("editPostData_____", postData);
  };

  const hideEditShareModalInfo = () => {
    setShowEditModal(false);
    setEditPostData({});
    window.$("#editShareYourThoughtsModal").modal("hide");
  };

  const images = postInfo
    ?.filter((img) => img?.cropTypeName === "original")
    .map((img) => img?.imageUploadpath);

  return (
    <Dialog
      open={show}
      onClose={onHide}
      maxWidth='lg'
      className='custom-table-dialog less-z'
      fullWidth
    >
      <ToastContainer />
      <div className='modal-content-wrapper-post'>
        {/* Close button */}
        <Button variant='light' className='close-button' onClick={onHide}>
          &times;
        </Button>

        {/* Image Slider */}
        <div className='top-section table-slider-container-post position-relative'>
          <CustomImageSlider images={images} />
        </div>

        {/* Post Details , Restaurant Name */}
        <div className='p-4 section-post-PostDetails'>
          <div className='d-flex align-items-center justify-content-between'>
            <div className='d-flex align-items-center gap-1'>
              <img
                src={restaurantLogo}
                alt='restaurantLogo'
                className='postOwnerImg me-2'
              />
              <h6>{restaurantName}</h6>
            </div>

            <div class='dropdown'>
              <span
                class='dropdown-toggle three-dot'
                id='dropdownMenuButton1'
                data-bs-toggle='dropdown'
                aria-expanded='false'
                style={{ cursor: "pointer" }}
              >
                <i class='fas fa-ellipsis-v'></i>
              </span>
              <ul class='dropdown-menu' aria-labelledby='dropdownMenuButton1'>
                <li>
                  <button
                    class='dropdown-item'
                    onClick={() => showEditShareModalInfo(postData)}
                  >
                    Edit post
                  </button>
                </li>
                <li>
                  <button
                    class='dropdown-item'
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      removePost(postData.postId, postData.postInfoId)
                    }
                  >
                    Delete
                  </button>
                </li>
                {/* <li><a class="dropdown-item" href="#">Subscribe</a></li> */}
              </ul>
            </div>
          </div>
          <h4
            className='mt-2 post-caption'
            style={{
              maxWidth: "370px",
              textWrap: "wrap",
            }}
          >
            {postData?.description}
          </h4>
        </div>
      </div>

      {showEditModal && (
        <EditShareYourThoughtsModal
          show={showEditModal}
          setShow={setShowEditModal}
          showEditShareModalInfo={showEditShareModalInfo}
          hideEditShareModalInfo={hideEditShareModalInfo}
          data={editPostData}
        />
      )}
    </Dialog>
  );
}
